// Canonical V2 settings gear.
//
// Geometry, stroke and sizing are the exact values already shipping on
// /program/cycles/:id (`lz-cycle-viewer__gear-icon`). Extracted here so other
// V2 surfaces reuse the canonical mark instead of redrawing it. The Cycle
// Viewer and Home keep their existing local copies untouched; consolidating
// them onto this component is a separate follow-up.
export default function GearIcon({ className = "lz-product-gear-icon" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="3.25" />
      <circle cx="12" cy="12" r="7.25" />
      <path d="M12 2.5v2.25M12 19.25v2.25M21.5 12h-2.25M4.75 12H2.5M18.7 5.3l-1.6 1.6M6.9 17.1l-1.6 1.6M18.7 18.7l-1.6-1.6M6.9 6.9 5.3 5.3" />
    </svg>
  );
}
